export default "__VITE_ASSET__Byx2_2U0__"